export default "__VITE_ASSET__DizQ_ufs__"